/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { EntityDirectoryResponseItem, EntityFileExplorerItem } from '../../Entities';

export const mapDirectoryToExplorerItem = (directory: EntityDirectoryResponseItem): EntityFileExplorerItem => {
  return {
    access: directory.access,
    id: directory.directoryId,
    lastModified: directory.updatedAt,
    path: directory.source,
    type: 'DIRECTORY',
    urls: directory.urls,
  };
};
